export enum TranslationsKeys {
  // Global
  TERMS = 'terms',
  COMMON = 'common',
  OLD_TRANSLATIONS = 'translation',
  // Peticiones
  PETITIONS = 'petitions',
  SURVEY = 'survey',
  // announcements
  ANNOUNCEMENTS_LIST = 'announcements/list',
  // degree-processes
  DEGREE_POOCESSES_DOCUMENTS = 'degree-processes/documents',
  DEGREE_POOCESSES_MAIN = 'degree-processes/main',
}

export const TranslatonsArray = Object.values(TranslationsKeys);
